const API_URL = process.env.REACT_APP_SERVER_API_URL;

export const fetchForMamaCampaignByOrganization = async ({ queryKey }) => {
  try {
    const [_key, { authToken, organizationId }] = queryKey;
    const params = new URLSearchParams();
    params.append('idType', 'organisation');
    params.append('id', organizationId);
    const result = await fetch(`${API_URL}/api/for-mama/campaign/get-one?${params.toString()}`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
    });
    const parsedResult = await result.json();
    if (!result.ok) throw parsedResult;
    return parsedResult.data;
  } catch (error) {
    throw error;
  }
};

export const getFundraiserByCampaign = async ({ queryKey }) => {
  const [_key, { campaignUid, authToken }] = queryKey;
  try {
    let url = `${API_URL}/api/campaign/${campaignUid}/fundraiser`;
    let query = '';
    const result = await fetch(`${url}?${query}`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
    });

    const parsedResult = await result.json();

    if (!result.ok) {
      throw parsedResult;
    }
    return parsedResult.data;
  } catch (error) {
    throw error;
  }
}

export const uploadImages = async (authToken, formData) => {
  try {
    const result = await fetch(`${API_URL}/api/for-mama/campaign/upload-images`, {
      method: 'POST',
      headers: {
        authorization: authToken,
      },
      body: formData,
    });

    const parsedResult = await result.json();
    if (!result.ok) {
      throw parsedResult;
    }
    return parsedResult;
  } catch (error) {
    throw error;
  }
};

export const createForMamaCampaign = async (authToken, formData) => {
  try {
    const result = await fetch(`${API_URL}/api/for-mama/campaign`, {
      method: 'POST',
      headers: {
        authorization: authToken,
      },
      body: formData,
    });

    const parsedResult = await result.json();
    if (!result.ok) {
      throw parsedResult;
    }
    return parsedResult;
  } catch (error) {
    throw error;
  }
};

export const updateForMamaCampaign = async (authToken, campaignId, formData) => {
  try {
    const result = await fetch(`${API_URL}/api/for-mama/campaign/${campaignId}`, {
      method: 'PUT',
      headers: {
        authorization: authToken,
      },
      body: formData,
    });

    const parsedResult = await result.json();
    if (!result.ok) {
      throw parsedResult;
    }
    return parsedResult;
  } catch (error) {
    throw error;
  }
};

export const customMatchFundOrg = async ({ queryKey }) => {
  const [_key, { authToken }] = queryKey;
  try {
    const result = await fetch(`${API_URL}/api/for-mama/custom-match-org`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
    });
    const parsedResult = await result.json();
    if (!result.ok) throw parsedResult;
    return parsedResult.data;
  } catch (error) {
    throw error;
  }
}

export const fetchForMamaConfig = async ({ queryKey }) => {
  const [_key, { authToken }] = queryKey;
  try {
    const result = await fetch(`${API_URL}/api/for-mama/config`, {
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
    });
    const parsedResult = await result.json();
    if (!result.ok) throw parsedResult;
    return parsedResult.data;
  } catch (error) {
    throw error;
  }
};

export const storeForMamaConfig = async (authToken, data) => {
  try {
    const result = await fetch(`${API_URL}/api/for-mama/config`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'authorization': authToken,
      },
      body: JSON.stringify(data),
    });
    const parsedResult = await result.json();
    if (!result.ok) throw parsedResult;
    return parsedResult;
  } catch (error) {
    throw error;
  }
};
